import Cookies from 'js-cookie'
import ReactGA from 'react-ga'

function sendToGA() {
	ReactGA.initialize('UA-89140206-4')
	ReactGA.set({ page: window.location.pathname + window.location.search })
	ReactGA.pageview(window.location.pathname + window.location.search)
}

function sendToGAIfOkay() {
	if ('disable_ga=true' === window.location.href.split('?')[1]) {
		alert('Disabling GA from this device for 10 years via cookie')
		Cookies.set('GADisabled', 10 * 365)
	}

	if (Cookies.get('GADisabled')) {
		// console.log('Not sending to GA: GADisabled cookie found')
		return
	}

	if (-1 === window.location.hostname.search('anthony.astige.com')) {
		// console.log('Not sending to GA: Host name not matched')
		return
	}

	// console.log('Sending GA...')
	sendToGA()
}

sendToGAIfOkay()



// WEBPACK FOOTER //
// ./src/ga.js